import {
  Dialog,
  IconButton,
  Stack,
  Typography,
  List,
  ListItem,
  ListItemText,
  Divider,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import Close from "../../../../assets/icons/icon_close_dark.svg";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { Group } from "../../../../store/groups";
import { OtherActionType } from "../../../../utils/table/columnTypes/actions.columnType";

interface HandleGroupsProps {
  handleClose: () => void;
  handleSelectedGroup?: (item: Group, action: OtherActionType) => void;
  groups?: Group[];
}

const HandleGroupsModal = (props: HandleGroupsProps) => {
  const { groups, handleClose, handleSelectedGroup } = props;

  const { t } = useTranslation();

  const handleEdit = (group: Group) => {
    if (handleSelectedGroup) {
      handleSelectedGroup(group, OtherActionType.EDIT);
    }
  };

  const handleDelete = (group: Group) => {
    if (handleSelectedGroup) {
      handleSelectedGroup(group, OtherActionType.DELETE);
    }
  };

  return (
    <Dialog open={true} maxWidth="sm" fullWidth>
      <form>
        <Stack direction="column" gap={4} p={4}>
          <Stack direction="row" justifyContent="space-between">
            <Typography fontSize="30px" fontWeight={800}>
              {t("groups.add.handleExistingGroups")}
            </Typography>
            <IconButton onClick={handleClose}>
              <img alt="" src={Close} />
            </IconButton>
          </Stack>
          {groups && groups.length > 0 && (
            <Stack gap={2}>
              <Typography fontSize="18px" fontWeight={600}>
                {t("groups.list.title")}
              </Typography>
              <List sx={{ maxHeight: 300, overflow: "auto" }}>
                {groups.map((group, index) => (
                  <div key={group.id || index}>
                    <ListItem>
                      <ListItemText primary={group.name} />
                      <Stack direction="row" gap={1}>
                        <IconButton
                          size="small"
                          onClick={() => handleEdit(group)}
                        >
                          <EditIcon fontSize="small" />
                        </IconButton>
                        <IconButton
                          size="small"
                          onClick={() => handleDelete(group)}
                          sx={{
                            color: "error.main",
                          }}
                        >
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      </Stack>
                    </ListItem>
                    {index < groups.length - 1 && <Divider />}
                  </div>
                ))}
              </List>
            </Stack>
          )}
        </Stack>
      </form>
    </Dialog>
  );
};

export default HandleGroupsModal;
